import { render, staticRenderFns } from "./consulta-cadastro.vue?vue&type=template&id=612fc379"
import script from "./consulta-cadastro.vue?vue&type=script&lang=js"
export * from "./consulta-cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports